export const compareByWalkTime = (a, b) => {
  const aTime = a.time;
  const bTime = b.time;
  if (aTime < bTime) {
    return -1;
  } else if (aTime > bTime) {
    return 1;
  } else {
    return 0;
  }
}
